export default __webpack_public_path__ + "static/media/loader22.81453d27.gif";